import { render, staticRenderFns } from "./MoreDianManage.vue?vue&type=template&id=08e29d15&scoped=true"
import script from "./MoreDianManage.vue?vue&type=script&lang=js"
export * from "./MoreDianManage.vue?vue&type=script&lang=js"
import style0 from "./MoreDianManage.vue?vue&type=style&index=0&id=08e29d15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e29d15",
  null
  
)

export default component.exports